module.exports = __webpack_public_path__ + "assets/img/icon_glossary.b4c1c72b.png";